import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useDispatch } from 'react-redux';
// @ts-expect-error Could not find a declaration file for module
import { openAcademyToSoftwareModal } from '../../actions/AcademyToSoftware';
import UsageTracker from '../../utils/UsageTracker';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const InfoButtonModalOpener = ({
  selectedSoftware,
  key
}) => {
  const {
    isNotTablet
  } = useMediaQuery();
  const dispatch = useDispatch();
  const onClick = e => {
    e.stopPropagation();
    e.preventDefault();
    dispatch(openAcademyToSoftwareModal('INFO_BUTTON', selectedSoftware));
    UsageTracker.track('interaction', {
      action: 'academy-to-software-button-clicked',
      whichButton: 'info'
    });
  };
  return isNotTablet ? /*#__PURE__*/_jsx(IconButton, {
    "data-selected-software-icon": selectedSoftware,
    "data-test-id": "academy-to-software-desirability-info-icon-button",
    marginInlineStart: "200",
    onClick: onClick,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.softwareDesirability.infoButton`
    }),
    use: "link",
    children: /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(HelpIcon, {
        alignWithText: true,
        color: "icon-core-subtle",
        size: "500",
        title: ""
      }, key)
    })
  }) : null;
};
export default InfoButtonModalOpener;